module.exports = __webpack_public_path__ + "static/img/core-item-4.9c014f8.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/zeroCodePhone/core-item-4.png
// module id = GJVA
// module chunks = 0